// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#wrapper {
    padding: 0;
    position: relative;
    z-index: 5;
    background: #fff;
}
.image-text-wrapper h1 {
    color: #fff;
    font-size: 50px;

}
.image-wrapper {
    margin-top: 100px;

}
.component-banner {
    margin-bottom: 20px;
}

.slick-dots li button:before {
    font-size: 12px!important;
}
b {
    font-weight:800!important;
}
 /* .image-wrapper {
   
    clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 83%);
} */
.image-wrapper img {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 88%);
}
.image-text-wrapper p {
    color: #fff;
    font-size: 24px;
    margin-top: 50px;
    margin-bottom: 40px;
    font-weight: 300;

}
.pnp-bg {
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
}

.layout .layout-row {
    flex-direction: column;
}

@media (min-width: 992px) {
    .layout .layout-row {
        flex-direction: row;
    }
}

.component-banner {
    width: 100%;
    position: relative;
    overflow: hidden;
     background: #333;
}

.text-orange {
    color: #ff5800;
}
.drop-shadow {
    background-color: rgba(0, 0, 0, 1);
    z-index: 1;
    transition: background-color 0.5s;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.bg-video {
    position: absolute;
    top: 50%;
    left: 50%;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
    transform: translate(-50%, -50%);
    pointer-events: none;
}

.video-text {
    position: absolute;
    bottom: 0;
    left: 10%;
    width: 60%;
    z-index: 6;
    font-size: 45px;
    font-weight: light;
    text-align: left;
    float: left;
    padding-bottom: 4%;
    padding-right: 8%;
    color: #fff;
    line-height: initial;
}

/* 
.video-left-text {
    padding: 0 30px;
} */

/* .image-text-wrapper {
} */

@media (max-width: 1024px) {
    .image-text-wrapper {
        width: 100%;
        height: 100%;
        align-items: center;
        display: flex;
        flex-direction: column-reverse;
        justify-content: center;
    }

    .video-text {
        display: flex;
        justify-content: center;
        align-items: center;
        padding-right: 20px;
        padding-left: 20px;
        text-align: center;
        position: relative;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
        font-size: 10px;
    }
}
@media (max-width: 575.98px) { 
    .component-banner {
        margin-bottom: 15px;
    }
    .image-wrapper {
        margin-top: 70px;
    }
    .image-text-wrapper h1 {
        font-size: 24px;
    padding-top: 10px;
    }
    .video-left-text {
        padding: 0;
    }
    .image-text-wrapper p {
        margin-top:20px;
        font-size: 18px;
    }
    .home-service-img {
        height: 100%!important;
    }
    .service-section .card .card-title {
        font-size: 24px!important;
        margin-top: 0;
    }
    .service-section .card p, .service-section .card a {
        font-size: 18px!important;
    }
    .service-section .card {
        margin-bottom: 0px!important;
    }
    .card-body {
        padding: 0;
    }
    .image-wrapper {
        clip-path: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/home/videoContainer.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;;AAEnB;AACA;IACI,iBAAiB;;AAErB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;CACC;;;GAGE;AACH;IACI,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;;AAEpB;AACA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;KACf,gBAAgB;AACrB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,UAAU;IACV,iCAAiC;IACjC,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,oBAAoB;AACxB;;AAEA;;;GAGG;;AAEH;GACG;;AAEH;IACI;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,aAAa;QACb,8BAA8B;QAC9B,uBAAuB;IAC3B;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;QACnB,kBAAkB;QAClB,kBAAkB;QAClB,kBAAkB;QAClB,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,eAAe;IACnB;AACJ;AACA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB,iBAAiB;IACjB;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;QACf,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,yBAAyB;QACzB,aAAa;IACjB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["#wrapper {\n    padding: 0;\n    position: relative;\n    z-index: 5;\n    background: #fff;\n}\n.image-text-wrapper h1 {\n    color: #fff;\n    font-size: 50px;\n\n}\n.image-wrapper {\n    margin-top: 100px;\n\n}\n.component-banner {\n    margin-bottom: 20px;\n}\n\n.slick-dots li button:before {\n    font-size: 12px!important;\n}\nb {\n    font-weight:800!important;\n}\n /* .image-wrapper {\n   \n    clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 83%);\n} */\n.image-wrapper img {\n    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 88%);\n}\n.image-text-wrapper p {\n    color: #fff;\n    font-size: 24px;\n    margin-top: 50px;\n    margin-bottom: 40px;\n    font-weight: 300;\n\n}\n.pnp-bg {\n    background-size: cover;\n    background-position: 50%;\n    background-repeat: no-repeat;\n}\n\n.layout .layout-row {\n    flex-direction: column;\n}\n\n@media (min-width: 992px) {\n    .layout .layout-row {\n        flex-direction: row;\n    }\n}\n\n.component-banner {\n    width: 100%;\n    position: relative;\n    overflow: hidden;\n     background: #333;\n}\n\n.text-orange {\n    color: #ff5800;\n}\n.drop-shadow {\n    background-color: rgba(0, 0, 0, 1);\n    z-index: 1;\n    transition: background-color 0.5s;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n\n.bg-video {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    min-width: 100%;\n    min-height: 100%;\n    width: auto;\n    height: auto;\n    transform: translate(-50%, -50%);\n    pointer-events: none;\n}\n\n.video-text {\n    position: absolute;\n    bottom: 0;\n    left: 10%;\n    width: 60%;\n    z-index: 6;\n    font-size: 45px;\n    font-weight: light;\n    text-align: left;\n    float: left;\n    padding-bottom: 4%;\n    padding-right: 8%;\n    color: #fff;\n    line-height: initial;\n}\n\n/* \n.video-left-text {\n    padding: 0 30px;\n} */\n\n/* .image-text-wrapper {\n} */\n\n@media (max-width: 1024px) {\n    .image-text-wrapper {\n        width: 100%;\n        height: 100%;\n        align-items: center;\n        display: flex;\n        flex-direction: column-reverse;\n        justify-content: center;\n    }\n\n    .video-text {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding-right: 20px;\n        padding-left: 20px;\n        text-align: center;\n        position: relative;\n        width: 100%;\n        padding-left: 20px;\n        padding-right: 20px;\n        font-size: 10px;\n    }\n}\n@media (max-width: 575.98px) { \n    .component-banner {\n        margin-bottom: 15px;\n    }\n    .image-wrapper {\n        margin-top: 70px;\n    }\n    .image-text-wrapper h1 {\n        font-size: 24px;\n    padding-top: 10px;\n    }\n    .video-left-text {\n        padding: 0;\n    }\n    .image-text-wrapper p {\n        margin-top:20px;\n        font-size: 18px;\n    }\n    .home-service-img {\n        height: 100%!important;\n    }\n    .service-section .card .card-title {\n        font-size: 24px!important;\n        margin-top: 0;\n    }\n    .service-section .card p, .service-section .card a {\n        font-size: 18px!important;\n    }\n    .service-section .card {\n        margin-bottom: 0px!important;\n    }\n    .card-body {\n        padding: 0;\n    }\n    .image-wrapper {\n        clip-path: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
